import { assert_string_not_empty } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { MAP__serializable } from '@shared/dto/_base/MAP__serializable';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class DTO_RESPONSE__grid2d_download_images extends DTO__base {
  static _class_name_static: string = ENUM__dto_class_name.RESPONSE_GRID2D_DOWNLOAD_IMAGES;

  /*
   * FIELDS
   */

  grid2d_id!: string;

  //key - image_id, value - url_relative
  images_map!: MAP__serializable<string, string>;

  /*
   * METHODS
   */

  constructor() {
    super();
    this.images_map = new MAP__serializable();
  }

  assert_standard_fields(): void {
    assert_string_not_empty(this.grid2d_id);
  }
}
